import styled from 'styled-components';
import { colors, sizes } from 'constants/theme';

export default styled.p`
  color: ${colors.danger};
  margin: 0 0 1rem 0;
  font-size: ${sizes.smallerText};
`;
